import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerFragmentDoc, SettingsPagePlannerSpecialtyFragmentDoc } from '../SettingsPage/SettingsPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchViewerOnChatPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchViewerOnChatPageQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, hasLineActivationProvider: boolean }, uiControl: { __typename?: 'UIControl', viewMatchedRooms: boolean, viewBranchMemberRooms: boolean, viewCorporationMemberRooms: boolean } };

export type ChatPageUiControlFragment = { __typename?: 'UIControl', viewMatchedRooms: boolean, viewBranchMemberRooms: boolean, viewCorporationMemberRooms: boolean };

export type FetchPlannerOnChatPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchPlannerOnChatPageQuery = { __typename?: 'Query', planner?: { __typename?: 'Planner', id: string, name: string, slug: string, avatar?: any | null, avatarUrl: string, cover?: any | null, coverUrl?: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday?: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ __typename?: 'PlannerSpecialty', id: string, name: string }> } | null };

export const ChatPageUiControlFragmentDoc = gql`
    fragment ChatPageUIControl on UIControl {
  viewMatchedRooms
  viewBranchMemberRooms
  viewCorporationMemberRooms
}
    `;
export const FetchViewerOnChatPageDocument = gql`
    query fetchViewerOnChatPage {
  viewer {
    id
    hasLineActivationProvider
  }
  uiControl {
    ...ChatPageUIControl
  }
}
    ${ChatPageUiControlFragmentDoc}`;

/**
 * __useFetchViewerOnChatPageQuery__
 *
 * To run a query within a Vue component, call `useFetchViewerOnChatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchViewerOnChatPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchViewerOnChatPageQuery();
 */
export function useFetchViewerOnChatPageQuery(options: VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>(FetchViewerOnChatPageDocument, {}, options);
}
export function useFetchViewerOnChatPageLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>(FetchViewerOnChatPageDocument, {}, options);
}
export type FetchViewerOnChatPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>;
export const FetchPlannerOnChatPageDocument = gql`
    query fetchPlannerOnChatPage {
  planner {
    ...SettingsPagePlanner
  }
}
    ${SettingsPagePlannerFragmentDoc}`;

/**
 * __useFetchPlannerOnChatPageQuery__
 *
 * To run a query within a Vue component, call `useFetchPlannerOnChatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlannerOnChatPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchPlannerOnChatPageQuery();
 */
export function useFetchPlannerOnChatPageQuery(options: VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>(FetchPlannerOnChatPageDocument, {}, options);
}
export function useFetchPlannerOnChatPageLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>(FetchPlannerOnChatPageDocument, {}, options);
}
export type FetchPlannerOnChatPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>;